import React, { ReactNode, useCallback } from 'react';
import { RouteNames, ParamModel } from '@om-fe/core/core/routing/utils';
import { IconSize } from '@om-fe/core/utils/config';
import { ParticipantModel, TournamentModel } from '@om-fe/models';
import {
    WidgetsLink,
    WidgetsRouteName,
    SportRouteInComponentProps,
    WidgetsRouteChangeDetails,
    RouteChangeHandler,
    FlagIcon,
    FlagIconLocations,
    bemSlider,
    DisciplineIcon,
    ParticipantIcon,
} from '@om-fe/widgets'

interface FavoriteNavItemProps extends SportRouteInComponentProps {
    readonly id: string;
    readonly list: ParticipantModel | TournamentModel;
    readonly activeTab?: string;
}

export interface RouteParams {
    readonly disciplineId: string;
    readonly disciplineName: string;
    readonly locationId?: string;
    readonly locationName?: string;
    readonly sportLocationId?: string;
    readonly sportLocationName?: string;
    readonly tournamentId: string;
    readonly tournamentName: string;
    readonly eventCategoryId: string;
    readonly eventCategoryName: string;
    readonly participantId: string;
}

function FavoritesNavItem(
    {
        id,
        activeTab,
        list,
        onRouteChange,
    }: FavoriteNavItemProps
) {
    const routeParamsTournamentLocation: ParamModel = {
        sportId: list.sportId,
        locationId: list?.venueId || undefined,
        tournamentId: list._type === 'TOURNAMENT' ? list.id : undefined,
        participantId: list._type === 'PARTICIPANT'? list.id : undefined,
    };

    const handleRouteChange: RouteChangeHandler<WidgetsRouteName.Sport> = useCallback((details: WidgetsRouteChangeDetails<WidgetsRouteName.Sport>) => {
        onRouteChange?.(details);
    }, [onRouteChange]);

    const content: ReactNode = (
        <>
            {list.sportId && (
                <div className={bemSlider('ItemIcon')}>
                    <DisciplineIcon disciplineId={list.sportId}  />
                </div>
            )}
            {list._type === 'PARTICIPANT' && list.logoUrl && (
                <ParticipantIcon
                    logoUrl={list.logoUrl}
                    disciplineId={list.sportId}
                    size={IconSize.Medium1}
                />
            )}
            {
                list._type === 'TOURNAMENT' && (
                    <FlagIcon locationId={list.venueId ?? FlagIconLocations.World} />
                )
            }
            <div className={bemSlider('ItemText')}>
                {list.shortTranslatedName ?? list.translatedName}
            </div>
        </>
    );
    
    return (
        <WidgetsLink
            onRouteChange={handleRouteChange}
            name={RouteNames.Favorites}
            route={RouteNames.Sport}
            params={routeParamsTournamentLocation}
            className={(id === activeTab) ? bemSlider('Action isSelected') : bemSlider('Action')}
        >
            {content}
        </WidgetsLink>
    )
};

export default FavoritesNavItem;
